import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

function Background(props)
{
    //===========================================================================
    useEffect(() => {
        componentDidMount();
        return componentWillUnmount;
    }, []);
    //===========================================================================

    function componentDidMount()
    {
    }

    function componentDidUpdate()
    {

    }
    
    function componentWillUnmount()
    {
        
    }

    return (
        <div className={styles.background}>
            <img id={props.bgImgId}></img>
        </div>
    );
}

export default Background;